import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";

export const updateStock = createAsyncThunk(
  "stock/updateStock",
  async (stockPayload, { rejectWithValue }) => {
    try {
      const response = await apiService.put("/items/add_stock", stockPayload);
      return response.data;
    } catch (errors) {
      handleError(errors);
      return rejectWithValue(errors.response?.data?.errors || errors.message);
    }
  }
);

const stockSlice = createSlice({
  name: "stock",
  initialState: {
    loading: false,
    success: false,
    error: null,
  },
  reducers: {
    resetStockState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateStock.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateStock.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(updateStock.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      });
  },
});

export const { resetStockState } = stockSlice.actions;

export default stockSlice.reducer;
